import { GetOfferComments, GetOfferCommentsVariables } from "_graphql/queries/kek/__generated__/GetOfferComments";

import { getOfferComments } from "_graphql/kek/queries/offers.kek";
import { useQuery } from "@apollo/client";

export const useOfferComments = (variables?: GetOfferCommentsVariables) => {
    const { data, ...rest } = useQuery<GetOfferComments, GetOfferCommentsVariables>(getOfferComments, { variables, fetchPolicy: "network-only" });

    return {
        comments: data?.getOfferComments || [],
        ...rest
    }
}